<template>
    <div class="footer d-flex flex-lg-column py-2">
        <div class="container">
            <div class="d-flex flex-md-row align-items-center justify-content-between">
                <div class="text-dark order-1 py-2">
                    <span class="text-muted font-weight-bold mr-2">&copy; 2024</span>
                    <span class="text-dark-75">Kema. All rights reserved.</span>
                </div>

                <!--
                <div class="nav nav-dark order-2">
                    <router-link :to="{name:'about'}" v-slot="{href, navigate}">
                        <a :href="href" class="nav-link mr-3 px-1" @click="navigate">About</a>
                    </router-link>

                    <router-link :to="{name:'contact'}" v-slot="{href, navigate}">
                        <a :href="href" class="nav-link pl-1 pr-0" @click="navigate">Contact</a>
                    </router-link>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer"
};
</script>
